/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "igniteui-react-core";
import { StringBuilder } from "igniteui-react-core";
/**
 * @hidden
 */
var RippleVisualModelExport = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(RippleVisualModelExport, _super);
    function RippleVisualModelExport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.a = null;
        _this.b = null;
        _this.f = 0;
        _this.d = false;
        _this.c = false;
        _this.e = false;
        return _this;
    }
    RippleVisualModelExport.prototype.g = function () {
        var a = new StringBuilder(0);
        a.l("{");
        a.l("ActualHoverColor : " + this.a.serialize() + ", ");
        a.l("ActualRippleColor : " + this.b.serialize() + ", ");
        a.l("RippleDuration : " + this.f + ", ");
        a.l("IsDisabled : " + this.d + ", ");
        a.l("IsCentered : " + this.c + ", ");
        a.l("IsHoverEnabled : " + this.e + ", ");
        a.l("}");
        return a.toString();
    };
    RippleVisualModelExport.$t = markType(RippleVisualModelExport, 'RippleVisualModelExport');
    return RippleVisualModelExport;
}(Base));
export { RippleVisualModelExport };
//# sourceMappingURL=RippleVisualModelExport.js.map
